import { Typography, Paper, IconButton, Tooltip } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { InfoOutlined } from '@mui/icons-material';
import { getColor } from '../../core/colors';
import { FormMetadata } from '../../core/api/clients';
import useGetIncidents from '../../core/api/hooks/incident/useGetIncidents';
import IncidentDataGrid from '../../components/incident/IncidentDataGrid';

function IncidentLanding({ formMetadata }:{ formMetadata: FormMetadata }) {
  const incidentsData = useGetIncidents([], 168);
  if (!formMetadata) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return (<React.Fragment />);
  }
  return (
    <Box display="flex" flexDirection="column">
      <Typography variant="h6" sx={{ mb: 0, color: getColor(formMetadata.color)[500], fontWeight: 300 }}>
        Incidents (Last 7 days) - Note: Incidents are created on the 3rd day after the occurrence
        <Tooltip title="This section displays event reports from the last 7 days using the date the reports were created.">
          <IconButton>
            <InfoOutlined />
          </IconButton>
        </Tooltip>
      </Typography>
      <Paper variant="outlined" sx={{ mt: 0, mb: 1 }}>
        <IncidentDataGrid data={incidentsData} reportType="incident" pageSize={10} />
      </Paper>
    </Box>
  );
}

export default IncidentLanding;
